var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_135401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.16091 7.42893C5.76239 8.82745 4.80998 10.6093 4.42413 12.5491C4.03828 14.4889 4.23631 16.4996 4.99319 18.3268C5.75006 20.1541 7.03179 21.7159 8.67628 22.8147C10.3208 23.9135 12.2542 24.5 14.232 24.5C16.2098 24.5 18.1432 23.9135 19.7877 22.8147C21.4322 21.7159 22.7139 20.1541 23.4708 18.3268C24.2277 16.4996 24.4257 14.4889 24.0398 12.5491C23.654 10.6093 22.7016 8.82746 21.303 7.42893C19.4263 5.55622 16.8833 4.50448 14.232 4.50448C11.5807 4.50448 9.03768 5.55622 7.16091 7.42893V7.42893ZM17.1783 12.7322L15.4105 14.5L17.1783 16.2678C17.3345 16.424 17.4223 16.636 17.4223 16.857C17.4223 17.078 17.3345 17.29 17.1783 17.4463C17.022 17.6026 16.81 17.6904 16.589 17.6904C16.368 17.6904 16.156 17.6026 15.9997 17.4463L14.232 15.6785L12.4642 17.4463C12.3079 17.6026 12.096 17.6904 11.875 17.6904C11.6539 17.6904 11.442 17.6026 11.2857 17.4463C11.1294 17.29 11.0416 17.078 11.0416 16.857C11.0416 16.636 11.1294 16.424 11.2857 16.2678L13.0535 14.5L11.2857 12.7322C11.1294 12.576 11.0416 12.364 11.0416 12.143C11.0416 11.922 11.1294 11.71 11.2857 11.5537C11.442 11.3974 11.6539 11.3096 11.875 11.3096C12.096 11.3096 12.3079 11.3974 12.4642 11.5537L14.232 13.3215L15.9997 11.5537C16.156 11.3974 16.368 11.3096 16.589 11.3096C16.81 11.3096 17.022 11.3974 17.1783 11.5537C17.3345 11.71 17.4223 11.922 17.4223 12.143C17.4223 12.364 17.3345 12.5759 17.1783 12.7322Z",
    fill: "#535353"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_135401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.0898438 14.5) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFilter);
export default __webpack_public_path__ + "static/media/close-filter.2f5c27c1dc1b497fcc9e2ffe3798ad6f.svg";
export { ForwardRef as ReactComponent };